import { render } from "./BookSectionNavigation.vue?vue&type=template&id=5904ea13&scoped=true"
import script from "./BookSectionNavigation.vue?vue&type=script&lang=js"
export * from "./BookSectionNavigation.vue?vue&type=script&lang=js"

import "./BookSectionNavigation.vue?vue&type=style&index=0&id=5904ea13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5904ea13"]])

export default __exports__